import { createFileRoute } from "@tanstack/react-router";
import { AssistentePainelPage } from "@/paginas/pg_assistente/assistente-painel";

export const Route = createFileRoute("/_authenticated/assistente-painel")({
  head: () => ({
    meta: [
      { title: "Painel do assistente virtual — Milky Moo Palmares" },
      {
        name: "description",
        content:
          "Mensagens automáticas do assistente virtual da sorveteria, com confirmação de leitura por usuário.",
      },
      { property: "og:title", content: "Painel do assistente virtual — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Leitura e confirmação das mensagens geradas pelo assistente virtual.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: AssistentePainelPage,
});
